import { KeyFacet, stringPart, numberPart } from '@ms/items-view/lib/private/models/KeyFacet';

export const driveAppsKeyFacet: KeyFacet<{
  endpoint: string;
  driveId?: string;
}> = new KeyFacet('driveApps', {
  endpoint: stringPart(),
  driveId: stringPart({ shouldNormalizeToEmpty: true })
});

export const driveAppsExtensionKeyFacet: KeyFacet<{
  endpoint: string;
  extension: string;
  driveId?: string;
}> = new KeyFacet('driveAppsExtension', {
  endpoint: stringPart(),
  extension: stringPart(),
  driveId: stringPart({ shouldNormalizeToEmpty: true })
});

export const fileHandlerKeyFacet: KeyFacet<{
  id: string;
}> = new KeyFacet('fileHandlerKey', {
  id: stringPart()
});

export const fileHandlerActionKeyFacet: KeyFacet<{
  handlerId: string;
  id: number;
}> = new KeyFacet('fileHandlerActionKey', {
  handlerId: stringPart(),
  id: numberPart()
});

export const fileHandlerActionSetKeyFacet: KeyFacet<{
  type: string;
  extension?: string;
}> = new KeyFacet('fileHandlerActionSetKey', {
  type: stringPart(),
  extension: stringPart()
});

export const fileHandlerPreferenceKeyFacet: KeyFacet<{
  extension: string;
}> = new KeyFacet('fileHandlerPreferenceKey', {
  extension: stringPart(),
});